import { Controller } from "@hotwired/stimulus"

// Wraps a <details> reply toggle. Closes it once the reply submits successfully.
// (Clicking the summary again to close is native <details> behaviour.)
export default class extends Controller {
  close(event) {
    if (event.detail?.success) this.element.open = false
  }
}
